module.exports = __webpack_public_path__ + "img/logo Dowell.5a815933.svg";